import { CostosPlataformaService } from "../../generated/grpc/plataforma_costos_pb";
import { CostoEquipoResponse } from "../../response/costos/CostoEquipoResponse";
import { CostoEquipoPayload } from "../api/payload/costos/CostoEquipoPayload";
import { ServiceSaveBase } from "../base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { CostoEquipoListService, toCostoEquipoResponse } from "./CostoEquipoListService";

/** Alta y edición de equipos; el resultado reemplaza la fila del listado. */
export class CostoEquipoSaveService extends ServiceSaveBase<CostoEquipoResponse, CostoEquipoPayload> {
  static readonly instance = new CostoEquipoSaveService();
  private constructor() { super(); }

  protected readonly cache = CostoEquipoListService.instance;

  /** gRPC-Web (`GuardarEquipo`): sin `id` crea el equipo y su costo; con `id` edita ambos. */
  protected async sendSave(p: CostoEquipoPayload): Promise<CostoEquipoResponse> {
    const t = await grpcCall(() => grpcClient(CostosPlataformaService).guardarEquipo({
      id: p.id ?? undefined,
      nombre: p.nombre,
      unidad: p.unidad,
      precio: BigInt(p.precio),
      nota: p.nota ?? undefined,
      orden: p.orden,
    }));
    return toCostoEquipoResponse(t);
  }
}
